jQuery(document).ready(function($) {
    'use strict';

    // Hero Swiper
    var hero_swiper = new Swiper('.hero .swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
        },
    });

    // Grid Swiper

    $('.grid-swiper').each(function(index) {
        var $swiperObject = $(this);
        var swiperId = 'swiper-' + index;
        var paginationId = 'pagination-' + index;
        var nextId = 'next-' + index;
        var prevId = 'prev-' + index;

        // Add data-id attributes to the elements
        $(this).find('.swiper').attr('data-id', swiperId);
        $(this).find('.swiper-pagination').attr('data-id', paginationId);
        $(this).find('.swiper-button-next').attr('data-id', nextId);
        $(this).find('.swiper-button-prev').attr('data-id', prevId);

        // Selectors using the data-id attributes
        var swiperSelector = '[data-id="' + swiperId + '"]';
        var paginationSelector = '[data-id="' + paginationId + '"]';
        var nextSelector = '[data-id="' + nextId + '"]';
        var prevSelector = '[data-id="' + prevId + '"]';

        const swiper = new Swiper(swiperSelector, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            grabCursor: true,
            speed: 700,
            pagination: {
                el: paginationSelector,
                type: 'progressbar',
            },
            navigation: {
                nextEl: nextSelector,
                prevEl: prevSelector,
            },
            breakpoints: {
                768: {
                    spaceBetween: 32,
                    slidesOffsetBefore: 48,
                    slidesOffsetAfter: 48,
                },
                1024: {
                    spaceBetween: 32,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            }
        });

    });
    // Image gallery

    var image_swiper = new Swiper('.image-slider.swiper', {
        grabCursor: true,
        speed: 700,
        pagination: {
            el: '.image-slider .swiper-pagination',
            type: 'fraction',
        },
        navigation: {
            nextEl: '.image-slider .swiper-button-next',
            prevEl: '.image-slider .swiper-button-prev',
        },
    });


});
